import m from 'mithril'
import moment from 'moment'
import BaseModel from './_base'

let _data = []
const constraints = {
   
}

class Analization extends BaseModel {
    constructor(args) {
        super(constraints)
        args = (args) ? args : {};
        this.sumOfMembers = args.sumOfMembers || 0;
        this.sumOfPhotos = args.sumOfPhotos || 0;
        this.sumOfArticles = args.sumOfArticles || 0;
        this.sumOfPayMembers = args.sumOfPayMembers || 0;
        
        this.sumOfMembersMonth = args.sumOfMembersMonth || 0;
        this.sumOfPhotosMonth = args.sumOfPhotosMonth || 0;
        this.sumOfArticlesMonth = args.sumOfArticlesMonth || 0;
        this.sumOfPayMembersMonth = args.sumOfPayMembersMonth || 0;

        this.sumOfLoginMonth = args.sumOfLoginMonth || 0;
    }

    static get data() {
        return _data;
    }

    static getDashboardInfo() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/manager/analization/dashboradinfo`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        })
    }

    

    static getMatchInfo() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/manager/analization/matchinfo`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        })
    }

    static fetchRemove(page) {
        var pageSize = 10
        Analization.loading = true
        page = (page === undefined) ? Analization.pageIndex : page
        return m.request({
            method: 'POST',
            url: `${window.BASE_URL}/api/manager/analization/removeReason?page=${page}`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            params: {
                page: page,
                pageSize: pageSize
            }
        }).then((response) => {
            Analization.pageIndex = page
            Analization.paging = {
                pageCount: response.last_page,
                pageNo: response.current_page,
                pageSize: response.per_page,
                totalRecordCount: response.total
            }
            _data = response.data
            Analization.loading = false
            return response.data
        })
    }



}
export default Analization
